module.exports = __webpack_public_path__ + "img/hr-red-asterisk-10.d0fdb7d3.png";